import axios from './axios'

export const get = async (service, req) => {
    try {
        return await axios.post(`/romons.dashboard/api/dashboard/${service}`, req)
    } catch (error) {
        throw error
    }
}